import { z } from 'zod';

/**
 * When a credit app is owed to a lender. A fallback lender is submitted to only
 * once every other lender is out, or once the only offers left carry qualifying
 * stips, so its submission waits until then.
 */
const CreditAppSubmissionTiming = {
    IMMEDIATE: 'IMMEDIATE',
    AFTER_OTHER_LENDERS: 'AFTER_OTHER_LENDERS',
};
/** The hours lenders decide in: weekdays, 9am to 5pm Eastern. Holidays count as open. */
const LENDER_BUSINESS_HOURS = {
    monday: { day: 'monday', open: '09:00', close: '17:00' },
    tuesday: { day: 'tuesday', open: '09:00', close: '17:00' },
    wednesday: { day: 'wednesday', open: '09:00', close: '17:00' },
    thursday: { day: 'thursday', open: '09:00', close: '17:00' },
    friday: { day: 'friday', open: '09:00', close: '17:00' },
};
const LENDER_BUSINESS_HOURS_TIMEZONE = 'America/New_York';
// The lenders with an adapter in backend-common. Any other lender is a Lenders
// document with no adapter, attached to a deal by hand. Code asks
// `isIntegratedLenderId` rather than reading this list.
const INTEGRATED_LENDER_IDS = ['FRF', 'IRONHORSE', 'OCTANE'];
/** Whether the lender has an adapter, enabled or not. Loads no adapter code. */
function isIntegratedLenderId(lenderId) {
    return INTEGRATED_LENDER_IDS.includes(lenderId);
}
// Deal fields are written through dotted Firestore update paths keyed by lender
// id, so an id is limited to characters that stay one path segment. Firestore
// auto-ids and the native ids both fit. Existence is not checked here: zod runs
// synchronously, so the write path that attaches a lender to a deal checks that
// the Lenders document exists.
const LENDER_ID_PATTERN = /^[A-Za-z0-9_-]+$/;
const LenderIdSchema = z
    .string()
    .regex(LENDER_ID_PATTERN, 'A lender id may contain only letters, digits, "_" and "-"');

export { CreditAppSubmissionTiming, INTEGRATED_LENDER_IDS, LENDER_BUSINESS_HOURS, LENDER_BUSINESS_HOURS_TIMEZONE, LenderIdSchema, isIntegratedLenderId };
//# sourceMappingURL=general.js.map
